"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react2 = _interopRequireDefault(require("cleave.js/react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextField = _interopRequireDefault(require("../TextField/TextField"));

var _excluded = ["className", "format", "inputRef", "options", "value"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FORMATS = {
  currency: {
    noImmediatePrefix: true,
    numeral: true,
    prefix: '$',
    rawValueTrimPrefix: true
  },
  date: {
    date: true,
    datePattern: ['m', 'd', 'Y']
  },
  phone: {
    blocks: [0, 3, 0, 3, 4],
    delimiters: ['(', ')', ' ', '-'],
    numericOnly: true
  }
};

var FormattedTextField = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(FormattedTextField, _React$Component);

  var _super = _createSuper(FormattedTextField);

  function FormattedTextField(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FormattedTextField);
    _this = _super.call(this, props);
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      hasValue: !!props.value
    };
    return _this;
  }

  (0, _createClass2.default)(FormattedTextField, [{
    key: "handleChange",
    value: function handleChange(event) {
      var hasValue = !!event.target.rawValue;
      this.setState({
        hasValue: hasValue
      });

      if (this.props.onChange) {
        this.props.onChange(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          className = _this$props.className,
          format = _this$props.format,
          inputRef = _this$props.inputRef,
          options = _this$props.options,
          value = _this$props.value,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var hasValue = this.state.hasValue;
      var classes = (0, _classnames.default)((_classNames = {}, (0, _defineProperty2.default)(_classNames, className, true), (0, _defineProperty2.default)(_classNames, 'ui-formatted-text-field', true), (0, _defineProperty2.default)(_classNames, 'ui-text-field--has-value', hasValue), _classNames));
      return /*#__PURE__*/_react.default.createElement(_TextField.default, (0, _extends2.default)({}, otherProps, {
        className: classes,
        onChange: this.handleChange,
        renderInput: function renderInput(props) {
          return /*#__PURE__*/_react.default.createElement(_react2.default, (0, _extends2.default)({}, props, {
            htmlRef: inputRef,
            options: options || FORMATS[format],
            value: value
          }));
        }
      }));
    }
  }]);
  return FormattedTextField;
}(_react.default.Component);

FormattedTextField.propTypes = {
  /** Type of formatted field. Either `currency`, `date`, or `phone`. */
  format: _propTypes.default.oneOf(Object.keys(FORMATS)),

  /** The ref of the input field. Do to a limitation in Cleave.js this must be a callback ref. [See here for more information](https://github.com/nosir/cleave.js/blob/master/doc/reactjs-component-usage.md#how-to-get-ref-of-the-input-field). */
  inputRef: _propTypes.default.func,

  /** Options passed to Cleave.js. */
  options: _propTypes.default.object
};
FormattedTextField.defaultProps = {};
var _default = FormattedTextField;
exports.default = _default;
//# sourceMappingURL=FormattedTextField.js.map